import { get, set, clear } from '@/utils/local';

export const TENANT_HEADER_NAME = '__tenant';
const TENANT_STORAGE_KEY = 'tenantId';
const ADMIN_MODE_STORAGE_KEY = 'tenantAdminMode';
export const ADMIN_TENANT_ID = '0000-0000-0000-0000';

export function getTenantId() {
    const cached = get(TENANT_STORAGE_KEY);
    if (!cached) {
        return '';
    }
    if (typeof cached === 'string') {
        return cached;
    }
    if (typeof cached === 'object') {
        if (cached.value) {
            return cached.value;
        }
        if (cached.id) {
            return cached.id;
        }
        if (cached.tenantId) {
            return cached.tenantId;
        }
    }
    return '';
}

export function setTenantId(tenantId) {
    if (tenantId) {
        set(TENANT_STORAGE_KEY, tenantId);
        if (tenantId === ADMIN_TENANT_ID) {
            set(ADMIN_MODE_STORAGE_KEY, true);
        } else {
            clear(ADMIN_MODE_STORAGE_KEY);
        }
    } else {
        clearTenantId();
    }
}

export function clearTenantId() {
    clear(TENANT_STORAGE_KEY);
    clear(ADMIN_MODE_STORAGE_KEY);
}

export function isAdminMode() {
    return !!get(ADMIN_MODE_STORAGE_KEY);
}

export function applyTenantHeader(config) {
    const tenantId = getTenantId();
    if (!config.headers) {
        config.headers = {};
    }
    if (tenantId) {
        config.headers[TENANT_HEADER_NAME] = tenantId;
    } else if (config.headers[TENANT_HEADER_NAME]) {
        delete config.headers[TENANT_HEADER_NAME];
    }
    return config;
}
